import { Document } from "mongoose";

export enum EChoirFileType {
    LOGO = 1,
    PHOTO = 2,
}
export interface ICh_File {
    _id: string,
    size: number;
    type: EChoirFileType;
    choir: string,
    expireAt: Date,
    extention: string,
    toBeDeleted?: boolean;
}

export interface ICh_FileDocument extends Document, Omit<ICh_File, "_id"> {}